export const EVENT_HALL_INFO_MODAL_IMAGE =
    'https://simplewine.ru/static/local/assets/images/degustations/degustations-tastingroom.jpg';
